import React from "react";
import Cta from "../cta/cta";

const LinkedinCta = () => {
  return (
    <Cta
      heading="Reach Your Ideal Customer With Us"
      firstCta="/signup"
      firstCtaText="Subscribe Now"
      secondCta="/contact-us"
      secondCtaText="Contact us"
    />
  );
};

export default LinkedinCta;
